import script from "./ComStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComStatus.vue?vue&type=script&setup=true&lang=ts"

import "./ComStatus.vue?vue&type=style&index=0&id=f56bbe38&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f56bbe38"]])

export default __exports__